import { useCallback } from 'react';
import { useQueryClient } from '@tanstack/react-query';
import { useCheckDocumentLockStatus } from 'components/editor/hooks/useCheckDocumentLockStatus';
import { useAppDispatch, useAppSelector } from '../grid/reduxStore/Store';
import { selectContentId } from '../grid/reduxStore/documentSettingsSlice';
import { useSocketClient } from 'providers/SocketContext';
import { ImportSectionsCommand } from '../UndoRedo/ImportSectionsCommand';
import { UndoRedoManagerCommandVersion } from '../UndoRedo/UndoRedoManagerCommandVersion';
import { QueryKeys } from 'utils/queryKeys';

export const useImportSection = () => {
  const dispatch = useAppDispatch();
  const checkDocumentLockStatus = useCheckDocumentLockStatus();
  const { socketClient } = useSocketClient();
  const queryClient = useQueryClient();
  const contentId = useAppSelector(selectContentId);

  return useCallback(
    async ({ afterSectionId, sourceContentIds }: { afterSectionId?: string; sourceContentIds: string[] }) => {
      const command = new ImportSectionsCommand({ dispatch, socketClient, checkDocumentLockStatus }, { sourceContentIds, afterSectionId });

      const addedSectionIds = await command.execute();

      if (addedSectionIds) {
        UndoRedoManagerCommandVersion.getUndoRedoManager().pushUndoRedoCommands(command);
        await queryClient.invalidateQueries({ queryKey: QueryKeys.documentImageLibraryImages(contentId) });
      }

      return addedSectionIds;
    },
    [dispatch, checkDocumentLockStatus, socketClient, queryClient, contentId]
  );
};
